import { type CSSProperties, type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconShareWebAndroid } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useOpenableControls } from '../../../../generic-hooks'

import { ProductBuyBoxSocialPopupModal } from './ProductBuyBoxSocialPopupModal'

export const ProductBuyBoxSocialPopup: FC = () => {
  const { handleClose, handleOpen, isOpen } = useOpenableControls(false)

  return (
    <>
      <Button
        onClick={handleOpen}
        size="medium"
        startIcon={<IconShareWebAndroid />}
        // eslint-disable-next-line react/forbid-component-props -- icon should have text color in this case, UX requirement
        style={{ '--button-icon-color': 'inherit' } as CSSProperties}
        type="button"
        variant="text"
      >
        <FormattedMessage id="general.label.day.share" />
      </Button>
      <ProductBuyBoxSocialPopupModal
        handleClose={handleClose}
        isOpen={isOpen}
      />
    </>
  )
}
